export default __webpack_public_path__ + "static/media/fulllogo.72a5ba72.svg";